import { CloudFunctions } from '@telespot/sdk';
import { type AffiliateExportRow } from '@telespot/domain';
import {
  type IExportOrganizationAffiliatesHandler,
  ExportOrganizationAffiliates,
} from '@telespot/management/use-cases';

/**
 * Client-side handler that delegates the members export to the
 * `exportOrganizationAffiliates` cloud function, which runs with the master key
 * so protected user fields (email) are included.
 */
export class ParseExportOrganizationAffiliatesHandler implements IExportOrganizationAffiliatesHandler {
  public execute(command: ExportOrganizationAffiliates): Promise<AffiliateExportRow[]> {
    return CloudFunctions.ExportOrganizationAffiliates(command.details.organizationId);
  }
}
